import React, { useContext } from 'react';
import { I18nextProvider } from 'react-i18next';
import { SnackbarProvider } from 'notistack';
import { CoreContext } from './context/index.js';

const withProviders = (WrappedComponent, { translation = false, snackbar = false }) => {
    const WithProviders = (props) => {
        const { i18n } = useContext(CoreContext);
        // eslint-disable-next-line react/jsx-props-no-spreading
        let component = React.createElement(WrappedComponent, { ...props });
        if (snackbar) {
            component = (React.createElement(SnackbarProvider, { maxSnack: 3, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center',
                } }, component));
        }
        if (translation) {
            component = React.createElement(I18nextProvider, { i18n: i18n }, component);
        }
        return component;
    };
    return WithProviders;
};

export { withProviders as w };
//# sourceMappingURL=withProviders-l3mjYkR2.js.map
